const __request = require(`./__request/__request_contentType_form`);

// 国际机票询价
const recordCount = (data) => {
let pParameter = {
    method: 'post',
    urlSuffix: '/flight/international/buyer/white/order/payChange',
    data:data
  }

  return __request(pParameter)
}
export default recordCount
